import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { BaseHttpService } from '../../services/basehttp.service';
import { Constants } from '../../constants';
import { ICustomAttribute } from '../../models/customAttribute.model';

@Injectable({
    providedIn: 'root'
})
export class CustomAttributeService {

    constants: Constants = new Constants();
    constructor(private http: BaseHttpService) { }

    getAttributes(): Observable<ICustomAttribute[]> {
        let attrs: ICustomAttribute[] = [];
        let subject = new Subject<ICustomAttribute[]>();
        this.http.get(this.constants.getAllAttributes).subscribe((response: ICustomAttribute[]) => {
            attrs = response;
            subject.next(attrs);
        });
        return subject.asObservable();
    }
    getAttributeByCategory(categoryType: string,categoryValue: string): Observable<ICustomAttribute[]> {
        //debugger;
        let subject = new Subject<ICustomAttribute[]>();
        this.http.getById(this.constants.getAttributeByCategory + '/' + categoryType, categoryValue).subscribe((response: ICustomAttribute[]) => {
            subject.next(response);
        });
        return subject.asObservable();
    }
    addOrUpdateAttribute(attrList: ICustomAttribute[]): Observable<ICustomAttribute[]> {
        let subject = new Subject<ICustomAttribute[]>();
        this.http.post(this.constants.createAttribute, attrList).subscribe((response: ICustomAttribute[]) => {
            subject.next(response);
        });
        return subject.asObservable();
    }   
    deleteAttribute(attrId: number): Observable<ICustomAttribute> {
        let subject = new Subject<ICustomAttribute>();
        this.http.delete(this.constants.deleteAttribute, attrId).subscribe((response: ICustomAttribute) => {
            subject.next(response);
        });
        return subject.asObservable();
    }
}